import { Controller } from "@hotwired/stimulus"

const ARRAY_KEYS = ["style", "collection", "price", "size", "orientation", "medium", "location", "colour"]
const PATH_ORDER = ["search", "medium", "size", "orientation", "style", "price", "colour", "collection", "location", "sort", "per"]
const PATH_DEFAULTS = { sort: "relevant", per: "20" }

// Checkbox checked → segment added to path
const FLAG_KEYS = { ready_to_hang: "hang", from_followeds: "follow" }
// Checkbox unchecked → segment added to path (inverted logic)
const INVERTED_FLAG_KEYS = { availability: "sold" }

export default class extends Controller {
  static values = { basePath: String }

  connect() {
    this.element.classList.remove("animate-pulse", "pointer-events-none")
  }

  change(event) {
    this.#updateIcon(event.target)
    const url = this.#buildUrl()
    history.pushState(null, "", url)
    Turbo.visit(url, { frame: "listings-grid" })
    document.addEventListener(
      "turbo:frame-load",
      () => window.scrollTo({ top: 0, behavior: "smooth" }),
      { once: true }
    )
  }

  #updateIcon(input) {
    if (input.type === "radio") {
      this.element.querySelectorAll(`input[type="radio"][name="${input.name}"]`).forEach(radio => {
        const img = radio.closest("label")?.querySelector("img[data-checked-src]")
        if (img) img.src = radio === input ? img.dataset.checkedSrc : img.dataset.uncheckedSrc
      })
    } else {
      const img = input.closest("label")?.querySelector("img[data-checked-src]")
      if (img) img.src = input.checked ? img.dataset.checkedSrc : img.dataset.uncheckedSrc
    }
  }

  #buildUrl() {
    const formData = new FormData(this.element)
    const parts = []

    for (const key of PATH_ORDER) {
      const values = ARRAY_KEYS.includes(key)
        ? formData.getAll(`${key}[]`).filter(Boolean)
        : [formData.get(key)].filter(Boolean)

      if (values.length > 0 && values.join("+") !== PATH_DEFAULTS[key]) parts.push(key, values.join("+"))
    }

    for (const [name, segment] of Object.entries(FLAG_KEYS)) {
      if (formData.get(name)) parts.push(segment)
    }

    for (const [name, segment] of Object.entries(INVERTED_FLAG_KEYS)) {
      if (!formData.get(name)) parts.push(segment)
    }

    return parts.length > 0 ? `${this.basePathValue}/${parts.join("/")}` : this.basePathValue
  }
}
